<template>
<div class="container">

	<vue-form v-on:submit="saveDetails" :working="statusWorking" size="xsm" :readonly="readonly">

		<section>
		<h2>Personal Details</h2>
			<hr>

			<field label="First Name" col-class="col-md-4" v-model="detailsPayload.first_name"  :readonly="readonly"></field>
			<field label="Last Name" col-class="col-md-4" v-model="detailsPayload.last_name"  :readonly="readonly"></field>
			<field label="Email" col-class="col-md-4" v-model="detailsPayload.email" ></field>
			<field label="Phone: Home" col-class="col-md-4" v-model="detailsPayload.phone"  :readonly="readonly"></field>
			<field label="Phone: Mobile" col-class="col-md-4" v-model="detailsPayload.phone_mobile"  :readonly="readonly"></field>
		
		</section>
		<section>
			<h3>Address</h3>

			<address-manual-selector 
				:hide-suite="true"
				:address="detailsPayload.address"
				:city="detailsPayload.city"
				:province="detailsPayload.province"
				:country="detailsPayload.country"
				:postal-code="detailsPayload.postal_code"
				col-class="col-md-4"
				v-on:input="updateAddress">
			</address-manual-selector>

		</section>
		<section>
			<h3>Emergency Contact</h3>

			<field label="Emergency Contact: Name" col-class="col-md-4" v-model="detailsPayload.emergency_contact_name"  :readonly="readonly"></field>
			<field label="Emergency Contact: Phone" col-class="col-md-4" v-model="detailsPayload.emergency_contact_phone"  :readonly="readonly"></field>
			<field label="Emergency Contact: Address" col-class="col-md-4" v-model="detailsPayload.emergency_contact_address" :params="{type: 'textarea'}" :readonly="readonly"></field>
		</section>
	</vue-form>

</div>

</template>

<script>

import VueForm from "@/components/VueForm"
import Field from "@/components/Field"

import AddressManualSelector from "@/components/AddressManualSelector"

export default {

	name: 'NewEmployee',
	components: {
		Field,
		VueForm,
		AddressManualSelector
	},
	data() {
		return {
			statusWorking: false,
			readonly: false,
			detailsPayload: {},
			step: 1
		}
	},
	methods: {
		updateAddress(address) {
			let vm = this

			Object.keys(address).forEach((key,index) => {
				vm.$set(vm.detailsPayload,key,address[key])
			})
		},
		saveDetails() {
			let vm = this

			this.statusWorking = true

			this.detailsPayload.addToCompany = true

			this.postData("User/save",this.detailsPayload).then(function(response){

				vm.statusWorking = false

				if (response.success) {	

					// Helper function to handle route push and alert
					let proceedWithRoute = function() {
						if (vm.$route.path == "/employee/new") {
							vm.$router.push("/employee/"+response.slug+"/employment-settings")
							vm.alertSaved("New user created! A welcome email with their login credentials has been sent.")
						}
						else
							vm.alertSaved("Saved!")
					}

					// If freemium user, silently update EmployeeSetting with is_service_tech=1 before route push
					if (vm.isFreemiumUser) {
						let userId = response.data && response.data.record_id ? response.data.record_id : response.record_id
						let tenantId = vm.$store.userDetails.tenant_id

						if (userId && tenantId) {
							let employeeSettingPayload = {
								user_id: userId,
								tenant_id: tenantId,
								is_service_tech: 1
							}

							// Update silently (no alerts) before route push
							vm.postData("EmployeeSetting/save", employeeSettingPayload, false)
								.then(() => proceedWithRoute())
								.catch(() => proceedWithRoute()) // Continue even if update fails
						}
						else {
							proceedWithRoute()
						}
					}
					else {
						proceedWithRoute()
					}

				}
				else {
					if ("errors" in response)
						vm.alertErrors(response.errors)
				}
			})
		}
	},
	created() {
		this.spinner(false)
	}

}
</script>

<style type="text/css">

</style>